import { useState, useEffect } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LineChart, Line } from "recharts";

const API = "/api";

export default function Dashboard() {
  const [data, setData] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => { cargarDatos(); }, []);

  const cargarDatos = async () => {
    setCargando(true);
    try {
      const r = await fetch(`${API}/chunks/dashboard`);
      const d = await r.json();
      setData(d);
    } catch(e) { setError("Error cargando datos"); }
    setCargando(false);
  };

  const fmt = (n) => n >= 1000000 ? `$${(n/1000000).toFixed(1)}M` : n >= 1000 ? `$${(n/1000).toFixed(0)}K` : `$${n}`;

  if (cargando) return <div style={{padding:"40px",textAlign:"center",color:"#666"}}>Cargando dashboard...</div>;
  if (error) return <div style={{padding:"40px",textAlign:"center",color:"#c0392b"}}>{error}</div>;
  if (!data) return null;

  const { ventas_por_fcl, resumen } = data;

  return (
    <div style={{padding:"24px",maxWidth:"1200px",margin:"0 auto"}}>
      <h2 style={{marginBottom:"8px"}}>📊 Dashboard Ejecutivo</h2>
      <p style={{color:"#666",marginBottom:"24px",fontSize:"13px"}}>Basado en tus documentos</p>

      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:"16px",marginBottom:"32px"}}>
        {[
          {label:"Total FCL",value:resumen.total_fcl,icon:"🚢"},
          {label:"Max Ingresos",value:fmt(resumen.max_ingresos),icon:"💰"},
          {label:"Max Utilidad",value:fmt(resumen.max_utilidad),icon:"📈"},
          {label:"Total Libras",value:resumen.total_libras?.toLocaleString()+"lb",icon:"⚖️"}
        ].map((k,i)=>(
          <div key={i} style={{background:"#1e1e2e",borderRadius:"12px",padding:"20px"}}>
            <div style={{fontSize:"28px",marginBottom:"8px"}}>{k.icon}</div>
            <div style={{fontSize:"22px",fontWeight:"bold",color:"#6c63ff"}}>{k.value}</div>
            <div style={{color:"#666",fontSize:"13px",marginTop:"4px"}}>{k.label}</div>
          </div>
        ))}
      </div>

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"24px",marginBottom:"24px"}}>
        <div style={{background:"#1e1e2e",borderRadius:"12px",padding:"20px"}}>
          <h3 style={{marginBottom:"16px",fontSize:"14px",color:"#a0a0b0"}}>INGRESOS POR FCL</h3>
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={ventas_por_fcl}>
              <CartesianGrid strokeDasharray="3 3" stroke="#2a2a3e" />
              <XAxis dataKey="fcl" stroke="#666" tick={{fill:"#888",fontSize:12}} label={{value:"FCL",position:"insideBottom",offset:-2,fill:"#666"}} />
              <YAxis stroke="#666" tick={{fill:"#888",fontSize:11}} tickFormatter={fmt} />
              <Tooltip formatter={(v)=>fmt(v)} contentStyle={{background:"#2a2a3e",border:"none",borderRadius:"8px",color:"white"}} />
              <Bar dataKey="ingresos" fill="#6c63ff" radius={[4,4,0,0]} name="Ingresos" />
              <Bar dataKey="costos" fill="#e74c3c" radius={[4,4,0,0]} name="Costos" />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div style={{background:"#1e1e2e",borderRadius:"12px",padding:"20px"}}>
          <h3 style={{marginBottom:"16px",fontSize:"14px",color:"#a0a0b0"}}>LIBRAS POR FCL</h3>
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={ventas_por_fcl}>
              <CartesianGrid strokeDasharray="3 3" stroke="#2a2a3e" />
              <XAxis dataKey="fcl" stroke="#666" tick={{fill:"#888",fontSize:12}} />
              <YAxis stroke="#666" tick={{fill:"#888",fontSize:11}} tickFormatter={v=>v>=1000?`${(v/1000).toFixed(0)}K`:v} />
              <Tooltip contentStyle={{background:"#2a2a3e",border:"none",borderRadius:"8px",color:"white"}} />
              <Bar dataKey="libras" fill="#27ae60" radius={[4,4,0,0]} name="Libras" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div style={{background:"#1e1e2e",borderRadius:"12px",padding:"20px"}}>
        <h3 style={{marginBottom:"16px",fontSize:"14px",color:"#a0a0b0"}}>UTILIDAD POR FCL</h3>
        <ResponsiveContainer width="100%" height={250}>
          <LineChart data={ventas_por_fcl}>
            <CartesianGrid strokeDasharray="3 3" stroke="#2a2a3e" />
            <XAxis dataKey="fcl" stroke="#666" tick={{fill:"#888",fontSize:12}} />
            <YAxis stroke="#666" tick={{fill:"#888",fontSize:11}} tickFormatter={fmt} />
            <Tooltip formatter={(v)=>fmt(v)} contentStyle={{background:"#2a2a3e",border:"none",borderRadius:"8px",color:"white"}} />
            <Legend />
            <Line type="monotone" dataKey="utilidad" stroke="#f39c12" strokeWidth={2} dot={{fill:"#f39c12",r:4}} name="Utilidad" />
            <Line type="monotone" dataKey="ingresos" stroke="#6c63ff" strokeWidth={2} dot={{fill:"#6c63ff",r:4}} name="Ingresos" />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div style={{textAlign:"right",marginTop:"16px"}}>
        <button onClick={cargarDatos} style={{padding:"10px 20px",background:"#2a2a3e",color:"#a0a0b0",border:"none",borderRadius:"8px",cursor:"pointer",fontSize:"13px"}}>🔄 Actualizar</button>
      </div>
    </div>
  );
}
